import Vue from 'vue'
import Vuex from 'vuex'
import Linq from 'linq';
import VueIdb from './idb'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        hydrated: false,
        abilities: [],
        abilityGroups: [],
        targetIndex: null,
        userAbilities: [
            null, null, null, null, null, null, null, null
        ],
        searchWord: ''
    },
    mutations: {
        'DELETE_INDEXED_DB'(){},
        addAbility(state, ability) {
            state.abilities.push(ability)
        },
        setAbility(state, payload) {
            if (!('id' in payload)) {
                return;
            }
            let ability = Linq.from(state.abilities)
                .where(ability => ability.id === payload.id)
                .first();
            if (!ability) return;
            if ('visible' in payload) {
                ability.visible = payload.visible ;
            }
            if ('matched' in payload) {
                ability.matched = payload.matched;
            }
        },
        setAbilities(state, payload) {
            state.abilities.splice(0, state.abilities.length, payload.abilities);
        },
        addGroup(state, doc) {
            let group = doc.data();
            group.id = doc.id;
            state.abilityGroups.push(group)
        },
        setTargetIndex(state, index) {
            state.targetIndex = index;
        },
        setUserAbility(state, payload) {
            let ability = Linq.from(state.abilities)
                .where(x => x.id === payload.id)
                .firstOrDefault(null);
            state.userAbilities.splice(payload.index, 1, ability);
        },
        setUserAbilities(state, payload) {
            state.userAbilities.splice(0, state.userAbilities.length, payload);
        },
        clearAllUserAbility(state) {
            for (let i = 0; i < 8; i++) {
                state.userAbilities.splice(i, 1, null);
            }
        },
        setSearchWord(state, payload) {
            state.searchWord = payload.searchWord;
        }
    },
    modules: VueIdb.modules,
    getters: {
        hydrated: state => state.hydrated
    },
    plugins: [VueIdb.plugin]
    // strict: true
});
